module.exports = __webpack_public_path__ + "img/hr-transition-6.6810a506.png";